import type { ReactElement } from "react";
import { useEffect, useState } from "react";

import { DotsLoader } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import type {
    SuggestedChipItemProps } from "app/pages/sales-intelligence/common-components/FilterSuggestionsBar/components/SuggestedChipItem/SuggestedChipItem";
import {
    SuggestedChipItem,
} from "app/pages/sales-intelligence/common-components/FilterSuggestionsBar/components/SuggestedChipItem/SuggestedChipItem";
import {
    StyledLoaderWrapper,
    StyledSuggestedChipsContainer,
    StyledFilterSuggestionsBar,
    StyledFilterSuggestionsTitle,
    StyledSuggestedWrapper,
    StyledSuggestIcon,
} from "./styles";

type SuggestionsBarProps = {
    suggestedItems: readonly SuggestedChipItemProps[];
    isLoading: boolean;
    isEnabled: boolean;
};

const FilterSuggestionsBar = ({ suggestedItems, isEnabled, isLoading }: SuggestionsBarProps): ReactElement => {
    const isSuggestionsReady = suggestedItems.length > 0;
    const [isSuggestionVisible, setIsSuggestionVisible] = useState(false);

    const isChipsLoading = isEnabled && isLoading;

    useEffect(() => {
        if (!isEnabled) {
            return setIsSuggestionVisible(false);
        }

        if (isLoading && !isSuggestionsReady) {
            return setIsSuggestionVisible(true);
        }

        if (isSuggestionsReady) {
            return setIsSuggestionVisible(true);
        }

        setIsSuggestionVisible(false);
    }, [isEnabled, isLoading, isSuggestionsReady]);

    return isSuggestionVisible ? (
        <StyledFilterSuggestionsBar>
            <StyledSuggestedWrapper>
                <StyledSuggestIcon
                    iconName="wand"
                    size="xs"
                />
                <StyledFilterSuggestionsTitle>
                    {translate("si.lead_gen_filters.categoryFilter.suggested")}
                </StyledFilterSuggestionsTitle>
                {isLoading && !isSuggestionsReady ? (
                    <StyledLoaderWrapper>
                        <DotsLoader />
                    </StyledLoaderWrapper>
                ) : null}
            </StyledSuggestedWrapper>

            {isSuggestionsReady ? (
                <StyledSuggestedChipsContainer
                    ChipComponent={SuggestedChipItem}
                    items={suggestedItems}
                    isLoading={isChipsLoading}
                />
            ) : null}
        </StyledFilterSuggestionsBar>
    ) : (
        <></>
    );
};

export default FilterSuggestionsBar;
